import mainStyle from "../mainStyle.module.scss";
import React, { useState, useEffect, memo } from 'react';
import { cloneDeep } from "lodash";
import { useTheme } from "@mui/material/styles";
import { Typography, Box } from "@mui/material";
import { useAuth } from "contexts/AuthContext";
import { jwtDecode } from 'jwt-decode';
// Service
import useDataSourceManager from "hooks/useDataSourceManager";
import { SolidButton } from "components/buttons/SolidButton";
import { OutlineButton } from "components/buttons/OutlineButton"
import MfaPhase1 from './mfaPhase/mfaPhase1.js';
import MfaPhase2 from './mfaPhase/mfaPhase2.js';
import MfaPhase3 from './mfaPhase/mfaPhase3.js';
import MfaPhase4 from './mfaPhase/mfaPhase4.js';

const checkMockup = process.env.REACT_APP_IS_MOCKUP;

const ModalforAuth = (props) => {
  const {
    title, content, 
    cancelBtn, saveBtn,
    setOpenModal,
    modalType, modalStep, 
    originUser, loadingPage
  } = props;
  const theme = useTheme();
  const { dataMap, getData, decodeTokenData, sendRequest, sendBatch } = useDataSourceManager();
  
  const { token } = useAuth();
  const[currntType, setCurrentType] = useState(modalType)
  const[currntStep, setCurrentStep] = useState(modalStep)
  const[userInfo, setUserInfo] = useState(null)
  const[backBtn, setBackBtn] = useState(null)
  const[nextBtn, setNextBtn] = useState(null)
  const[hasInitMfa, setHasInitMfa] = useState(false)

  const [mfaSetting, setMfaSetting] = useState(null)

  // for phase 1
  const [inputPw, setInputPw] = useState('')
  const [checkResponse, setCheckResponse] = useState('')
  // for phase 2 & phase 3
  const [inputOpt, setInputOpt] = useState(['', '', '', '', '', ''])
  // const [checkResponse2, setCheckResponse2] = useState('')

  const handleBack = () => {
    setBackBtn("Back")
    setNextBtn("Next")
    // setOpenModal(false);
    if(currntStep === 'p1'){
      setOpenModal(false);
    }else if(currntStep === 'p2'){
      setInputPw('')
      setCurrentStep('p1')
    }else if(currntStep === 'p4'){
      setInputOpt(['', '', '', '', '', ''])
      setCurrentStep('p2')
    }
  };

  const handleNext = () => {
    if (currntStep !== 'p4') {
      setBackBtn("Back")
      setNextBtn("Next")
    }
    // console.log(currntType, currntStep)
    if(currntStep === 'p1'){
      let tmpUser = cloneDeep(userInfo)
      tmpUser.password = inputPw;
      if(checkMockup === "true"){
        if(inputPw !== ''){
          setCurrentStep('p2')
        }else{
          let response = {
            status: 'error',
            msg: '密碼不正確'
          }
          setCheckResponse(response)
        }
      }else{
        checkUserPw(tmpUser)
      }
    }else if(currntStep === 'p2'){
      // if(currntType === 'app'){
      // }else if(currntType === 'email'){
      // }
      if(checkMockup === "true"){
        const isPass = inputOpt.every(item => 
          item.length === 1 &&
          (/^[a-z0-9]$/.test(item))
        );
        if(isPass){
          setCurrentStep('p4')
          setNextBtn("Finish")
          setBackBtn(null)
        }else{
          setOpenNoticeLog(true)
        }
      }else{
        const isPass = inputOpt.every(item => 
          item.length === 1 &&
          (/^[a-z0-9]$/.test(item))
        );
        if(isPass){
          const optStr = inputOpt.join('');
          verifyOptCode(optStr)
        }else{
          setOpenNoticeLog(true)
        }
      }
    }else if(currntStep === 'p4'){
      if(checkMockup === "true"){
        setOpenModal(false);
      }else{
        enableSetupMFA()
      }
    }

  }

  const checkUserPw = async(updateUser) => {
    const response = await sendRequest("casdoor/UserService/.checkUserPassword",
      null, null, updateUser
    );
    // const response = await UserService.checkUserPassword(updateUser, token)
    setCheckResponse(response)
    if(response.status === 'ok'){
      initSetupMFA()
    }
  }

  const initSetupMFA = async() => {
    if(hasInitMfa === false){
      setHasInitMfa(true)
      // const updateData = new URLSearchParams();
      // updateData.append("owner", userInfo.owner);
      // updateData.append("name", userInfo.name);
      // updateData.append("mfaType", currntType);
      let updateData = {
        owner: userInfo.owner,
        name: userInfo.name,
        mfaType: currntType,
      }

      // const response = await UserService.initMfaSetting(updateData, token)
      const response = await sendRequest("casdoor/UserService/.initMfaSetting",
        null, null, updateData
      );

      if(response.status === 'ok'){
        setMfaSetting(response.data)
        setCurrentStep('p2')
      }
    }else{
      setCurrentStep('p2')
    }
  }

  const verifyOptCode = async(optStr) => {
    // const updateData = new URLSearchParams();
    // updateData.append("owner", userInfo.owner);
    // updateData.append("name", userInfo.name);
    // updateData.append("mfaType", currntType);
    // updateData.append("passcode", optStr);
    // if(currntType === 'app'){
    //   updateData.append("secret", mfaSetting.secret);
    //   updateData.append("dest", undefined);
    // }else{
    //   updateData.append("secret", undefined);
    //   updateData.append("dest", userInfo.email);
    // }
    // updateData.append("countryCode", userInfo.countryCode);
    let updateData = {
      owner: userInfo.owner,
      name: userInfo.name,
      mfaType: currntType,
      passcode: optStr,
      countryCode: userInfo.countryCode,
      secret: (currntType === 'app')? mfaSetting.secret:undefined ,
      dest: (currntType === 'app')? undefined: userInfo.email ,
    }

    // const response = await UserService.verifyMfaSetting(updateData, token)
    const response = await sendRequest("casdoor/UserService/.verifyMfaSetting",
      null, null, updateData
    );

    if(response.status === 'ok'){
      setCurrentStep('p4')
      setNextBtn("Finish")
      setBackBtn(null)
    }else{
      setOpenNoticeLog(true)
    }
  }

  const enableSetupMFA = async() => {
    // const updateData = new URLSearchParams();
    // updateData.append("owner", userInfo.owner);
    // updateData.append("name", userInfo.name);
    // updateData.append("mfaType", currntType);
    // updateData.append("recoveryCodes", mfaSetting.recoveryCodes[0]);
    // if(currntType === 'app'){
    //   updateData.append("secret", mfaSetting.secret);
    //   updateData.append("dest", undefined);
    // }else{
    //   updateData.append("secret", undefined);
    //   updateData.append("dest", userInfo.email);
    // }
    // updateData.append("countryCode", userInfo.countryCode);
    let updateData = {
      owner: userInfo.owner,
      name: userInfo.name,
      mfaType: currntType,
      recoveryCodes: mfaSetting.recoveryCodes[0],
      countryCode: userInfo.countryCode,
      secret: (currntType === 'app')? mfaSetting.secret:undefined ,
      dest: (currntType === 'app')? undefined: userInfo.email ,
    }

    // const response = await UserService.enableMfaSetting(updateData, token)
    const response = await sendRequest("casdoor/UserService/.enableMfaSetting",
      null, null, updateData
    );

    if(response.status === 'ok'){
      setOpenModal(false);

      let tokenSetting = jwtDecode(token);
      loadingPage(tokenSetting.name)
    }else{
      setOpenNoticeLog(true)
    }
  }

  useEffect(() => {
    setCurrentType(modalType)
    setCurrentStep(modalStep)
    setUserInfo(originUser)
    setNextBtn(saveBtn)
    setBackBtn(cancelBtn)
  }, [setOpenModal]);

  const [openNoticeLog, setOpenNoticeLog] = useState(false);
  const handleNoticeLog = (e) => {
    setOpenNoticeLog(false)
  }
  const [openCapcha, setOpenCapcha] = useState(false);
  const handleCapchaCode = (e) => {
    setOpenCapcha(false)
  }

  return (
    <>
      <div className={mainStyle['modal_Block']} style={{margin:'10px 10px 20px 10px'}}>
        {title &&
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontSize: theme.typography.customFontSize[6],
              fontWeight: theme.typography.customFontWeight[3],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            {title}
          </Typography>
        }
      </div>
      <Box style={{marginBottom:'20px'}}>
        {/* MfaPhase1: for check password,  MfaPhase2: QR code verify & show secret for app, 
          MfaPhase3: verify for Email, MfaPhase4: show the recovery code */}
        {currntStep === 'p1' && 
          <MfaPhase1 setInputPw={setInputPw} checkResponse={checkResponse} />
        }
        {currntStep === 'p2' && currntType === 'app' && 
          <MfaPhase2 setInputOpt={setInputOpt} mfaSetting={mfaSetting}/>
        }
        {currntStep === 'p2' && currntType === 'email' && 
          <MfaPhase3 userSetting={originUser} setInputOpt={setInputOpt} />
        }
        {currntStep === 'p4' && 
          <MfaPhase4 mfaSetting={mfaSetting}/>
        }
      </Box>
      <div className={mainStyle['modal_Block']}>
        {backBtn && <Box style={{margin: '10px'}}>
          <OutlineButton width="195px" height="42px" onClick={handleBack}>
          {backBtn}
          </OutlineButton>
        </Box>}
        {nextBtn && <Box style={{margin: '10px'}}>
          <SolidButton width="195px" height="42px" onClick={handleNext}>
            {nextBtn}
          </SolidButton>
        </Box>}
      </div>      
      {openNoticeLog && <div className={mainStyle['modal_subLayer']} style={{}}>
        <div className={mainStyle['modal_subContent']} style={{}}>
          <div className={mainStyle['modal_Block']} style={{margin: '10px'}}>
            <Typography
              sx={{
                color: theme.palette.primary.main,
                fontSize: theme.typography.customFontSize[5],
                fontWeight: theme.typography.customFontWeight[3],
                fontFamily: theme.typography.fontFamily,
              }}
              >
              Invalid Verification Code
            </Typography>
          </div>
          <div className={mainStyle['modal_Block']} style={{margin: '10px'}}>
            <div>
              <Typography
                sx={{
                  color: theme.palette.primary.greyPrimary,
                  fontSize: theme.typography.customFontSize[4],
                  fontFamily: theme.typography.fontFamily,
                }}
                >
                The verification code you entered is invaild.
              </Typography>
              <Typography
                sx={{
                  color: theme.palette.primary.greyPrimary,
                  fontSize: theme.typography.customFontSize[4],
                  fontFamily: theme.typography.fontFamily,
                }}
                >
                Please check the code and try again.
              </Typography>
            </div>
            
          </div>
          <div className={mainStyle['modal_Block']}>
            <Box style={{margin: '10px'}}>
              <SolidButton width="100px" height="35px" onClick={handleNoticeLog}>
              Retry
              </SolidButton>
            </Box>
          </div>
        </div>
      </div >}
      {openCapcha && <div className={mainStyle['modal_subLayer']} style={{}}>
        <div className={mainStyle['modal_subContent']} style={{}}>
          <div className={mainStyle['modal_Block']} style={{margin: '10px'}}>
            <Typography
              sx={{
                color: theme.palette.primary.main,
                fontSize: theme.typography.customFontSize[5],
                fontWeight: theme.typography.customFontWeight[3],
                fontFamily: theme.typography.fontFamily,
              }}
              >
              Capcha
            </Typography>
          </div>
          <div className={mainStyle['modal_Block']} style={{margin: '10px'}}>
            <Typography
              sx={{
                color: theme.palette.primary.greyPrimary,
                fontSize: theme.typography.customFontSize[4],
                fontFamily: theme.typography.fontFamily,
              }}
              >
              Capcha content...
            </Typography>
          </div>
          <div className={mainStyle['modal_Block']}>
            <Box style={{margin: '10px'}}>
              <SolidButton width="100px" height="35px" onClick={handleNoticeLog}>
              Retry
              </SolidButton>
            </Box>
          </div>
        </div>
      </div >}

    </>
  );
}

export default memo(ModalforAuth);